import ChartNivDifferentieelDiagnoseAcuutAngioOedeem from "../../../../src/client/niv_acuteboekje/json/differentiaal-diagnose-acuut-angio-oedeem.json";
import ChartNivSimple from "../../../../src/client/niv_acuteboekje/interactions/simple/ChartNivSimple.js";
import ButtonSchematic from "../../../../src/client/niv_acuteboekje/ui/ButtonSchematic.js";
import * as React from 'react';
export default {
  ChartNivDifferentieelDiagnoseAcuutAngioOedeem,
  ChartNivSimple,
  ButtonSchematic,
  React
};